// Customer launch configuration only; never changes strategy/source participants.
module.exports={SUPPORTED_STATES:Object.freeze([['FL','Florida']])};
